<script>
import ImageLoader from '@components/ImageLoader'

export default {
  name: 'VideoPlayer',
  components: {
    ImageLoader
  },
  props: {
    width: {
      type: String,
      default: '50vw'
    }
  },
  data: () => ({
    videoHTML: undefined
  }),
  computed: {
    styles () {
      return {
        container: {
          '--container-width': this.width,
          '--container-height': 'calc(var(--container-width) * 0.6)'
        },
        image: {
          '--image-width': 'var(--container-width)',
          '--image-height': 'calc(var(--image-width) * 0.6)'
        },
        iframe: {
          '--iframe-width': 'calc(var(--container-width) * 0.75)',
          '--iframe-height': 'calc(var(--iframe-width) * 0.62)',
          '--iframe-margin-top': 'calc(var(--iframe-height) * 0.067)'
        }
      }
    }
  },
  async created () {
    const response = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(this.wl.urls.video)}`)
    if (response.status === 200) {
      const { html } = await response.json()
      this.videoHTML = html
    }
  }
}
</script>
<template>
  <div
    class="video-player-container"
    :style="styles.container"
  >
    <ImageLoader
      :style="styles.image"
      :url="wl.images.MACBOOK"
      class="macbook"
    />
    <iframe
      src="https://player.vimeo.com/video/420071378?app_id=122963"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen=""
      title="VIDEO WOLIFLIX SITE"
      class="iframe"
      :style="styles.iframe"
    />
  </div>
</template>

<style lang="scss" scoped>
.video-player-container {
  position: relative;
  width: var(--container-width);
  height: var(--container-height);
  > .macbook {
    width: var(--image-width);
    height: var(--image-height);
  }
  > .iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: var(--iframe-width);
    height: var(--iframe-height);
    margin-top: var(--iframe-margin-top);
  }
}
</style>
